// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Colors } from "../../../assets/Colors";
import { fetchGet, fetchPost, fetchPut } from "../../../fetchers";
import { useMutation } from "@tanstack/react-query";
import { DynamicTableSimple } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import { isRequired, useForm } from "../../../components/isRequired";
import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import "react-toastify/dist/ReactToastify.css";
import { BiArrowBack } from "react-icons/bi";
import { useLocation, useNavigate, useParams } from "react-router-dom";
const extractFileName = (fileString) => {
  if (!fileString) return "";

  // Jika format: UUID-namafile.ext
  if (fileString.includes("-")) {
    const parts = fileString.split("-");
    // Ambil bagian setelah UUID (bagian pertama)
    return parts.slice(1).join("-");
  }

  return fileString;
};

const ApprovalCashBank = ({}) => {
  let initialState = {
    BisnisUnitID: "",
    Tanggal: new Date(),
    FileName: "",
    File: "", // Tambahkan field File untuk menyimpan nama file UUID
  };

  let initialStateModal = {
    SDTDate: new Date(),
  };

  // Fungsi untuk membuka file via blob URL
  const getDataFromURL = (url) => {
    if (!url || url.trim() === "") {
      toast.error("Tidak ada file attachment", {
        position: "bottom-right",
        autoClose: 3000,
      });
      return;
    }

    // URL encode untuk menghandle karakter khusus
    const encodedUrl = encodeURIComponent(url);

    // Sesuaikan dengan endpoint file server Anda
    const fileUrl = process.env.REACT_APP_API_UPLOAD_URL
      ? `${process.env.REACT_APP_API_UPLOAD_URL}file/${encodedUrl}`
      : `http://192.168.212.24:5000/v1/files/${encodedUrl}`;

    fetch(fileUrl, {
      method: "GET",
      headers: {
        Accept: "application/octet-stream",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.blob();
      })
      .then((blob) => {
        // Buat blob URL
        const fileBlobUrl = window.URL.createObjectURL(blob);

        // Tentukan apakah akan membuka atau download
        if (blob.type.includes("pdf") || blob.type.includes("image")) {
          // Untuk PDF dan gambar, buka di tab baru
          window.open(fileBlobUrl, "_blank");
        } else {
          // Untuk file lain, download
          const link = document.createElement("a");
          link.href = fileBlobUrl;

          // Extract original filename from UUID format
          let downloadName = url;
          if (url.includes("-") && url.split("-")[0].length === 36) {
            const uuidParts = url.split("-");
            downloadName = uuidParts.slice(1).join("-").replace(/_/g, " ");
          }

          link.download = downloadName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // Cleanup blob URL setelah download
          setTimeout(() => URL.revokeObjectURL(fileBlobUrl), 100);
        }

        toast.success("File berhasil dibuka", {
          position: "bottom-right",
          autoClose: 2000,
        });
      })
      .catch((err) => {
        console.error("Error loading file:", err);
        toast.error(
          "Gagal membuka file. File mungkin belum diupload ke server.",
          {
            position: "bottom-right",
            autoClose: 3000,
          }
        );
      });
  };

  // Fungsi untuk mendapatkan icon file
  const getFileIcon = (fileName) => {
    if (!fileName) return "📎";
    const ext = fileName.split(".").pop().toLowerCase();
    if (["pdf"].includes(ext)) return "📄";
    if (["jpg", "jpeg", "png", "gif"].includes(ext)) return "🖼️";
    if (["doc", "docx"].includes(ext)) return "📝";
    return "📎";
  };

  const validations = [
    ({ UserPCName }) =>
      isRequired(UserPCName) || { UserPCName: "Nama UserPC wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Status wajib diisi" },
    ({ KelompokID }) =>
      isRequired(KelompokID) || { KelompokID: "Kelompok wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Kelompok wajib diisi" },
    ({ DetailAccountID }) =>
      isRequired(DetailAccountID) || {
        DetailAccountID: "Detail Account wajib diisi",
      },
    ({ Status }) =>
      isRequired(Status) || { Status: "Detail Account wajib diisi" },
  ];

  const {
    changed,
    values,
    isValid,
    touched,
    submitHandler,
    customHandler,
    changeHandler,
    errors,
    blastChange,
  } = useForm(initialState, validations);

  const barang = useMutation((formData) => fetchGet("Master/Barang/min"));
  const [buttonTouched, setButtonTouched] = useState(false);
  const [detail, setDetail] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [modalDetail, setModalDetail] = useState(initialStateModal);
  const [modalID, setModalID] = useState(0);
  const ModalOpener = (detail) => {
    setShowModal(true);
  };
  const param = useLocation();
  const params = useParams();

  const mutation = useMutation((formData) =>
    fetchPost("Master/UserPC", formData)
  );
  const mutationAdd = useMutation((formData) =>
    fetchPost("Accounting/CashJournal", formData)
  );
  const mutationGet = useMutation((formData) =>
    fetchGet("Accounting/CashJournal/" + formData)
  );
  const mutationUpdate = useMutation((formData) =>
    fetchPut("Accounting/CashJournal", formData)
  );
  const mutationApproval = useMutation((formData) =>
    fetchPost("Accounting/CashJournal/kirim", formData)
  );
  const detailAccount = useMutation((formData) =>
    fetchGet("GetMinMasterDetailAccountV2")
  );

  const ModalEdit = (detail, id) => {
    setModalID(id);
    setModalDetail(detail);
    setShowModal(true);
    setShowModalEdit(true);
  };

  const ModalDelete = (id) => {
    let newDetail = [...detail];
    newDetail.splice(id, 1);
    let totals = 0;
    newDetail.map(({ Nominal }, id) => {
      totals += parseFloat(Nominal);
    });
    customHandler(totals, "Nominal");
    setDetail(newDetail);
  };

  const navigate = useNavigate();

  useEffect(() => {
    detailAccount.mutate();
    barang.mutate();
    if (params.transid) {
      mutationGet.mutate(params.transid.toString().replaceAll("-", "/"));
    }
  }, []);

  useEffect(() => {
    if (mutationUpdate) {
      if (mutationUpdate.isSuccess) {
        // Kembali ke list asal (pettycash / penerimaan-kas / penerimaan-dana / kas-bank)
        navigate(-1);
      }
    }
  }, [mutationUpdate.status]);

  useEffect(() => {
    if (mutationAdd) {
      if (mutationAdd.isSuccess) {
        navigate(-1);
      }
    }
  }, [mutationAdd.status]);

  useEffect(() => {
    if (mutationApproval) {
      if (mutationApproval.isSuccess) {
        navigate(-1);
      }
    }
  }, [mutationApproval.status]);

  useEffect(() => {
    if (mutationGet.data && mutationGet.data.data && mutationGet.data.data[0]) {
      const tempData = mutationGet.data.data[0];
      setDetail(tempData.Data || []);

      // Set File dan FileName dari database (seperti di InsertKasBankPage)
      if (tempData.File && tempData.File.trim() !== "") {
        // Decode nama file dari UUID untuk display
        if (
          tempData.File.includes("-") &&
          tempData.File.split("-")[0].length === 36
        ) {
          const uuidParts = tempData.File.split("-");
          const originalName = uuidParts.slice(1).join("-").replace(/_/g, " ");
          customHandler(originalName, "FileName");
        } else {
          customHandler(tempData.File, "FileName");
        }
        customHandler(tempData.File, "File");
      }

      blastChange(tempData);
    }
  }, [mutationGet.status]);

  const header = [
    { name: "Account", key: "Account", modifiers: "Account" },
    { name: "Account Name", key: "Account", modifiers: "AccountName" },
    { name: "Keterangan", key: "Keterangan", modifiers: "Keterangan" },
    { name: "Nominal", key: "Nominal", modifiers: "Numbers" },
  ];

  const modalHandler = (value, names) => {
    const newValues = { ...modalDetail, [names]: value };
    setModalDetail(newValues);
  };

  const modalHandlerText = (event) => {
    const newValues = {
      ...modalDetail,
      [event.target.name]: event.target.value,
    };
    setModalDetail(newValues);
  };

  // NumberFormat (react-number-format) memanggil onValueChange dengan objek
  // {formattedValue, value, floatValue} — bukan event DOM — sehingga tampilan
  // boleh berpemisah-ribuan sementara nilai yang disimpan tetap angka murni
  // (pola sama dgn SaldoAwal.js).
  const modalHandlerNominal = (values) => {
    const newValues = { ...modalDetail, Nominal: values.floatValue?.toString() || "" };
    setModalDetail(newValues);
  };

  const inputBuilder = [
    {
      type: "DetailAccount",
      name: "Account",
      title: "Account",
      handler: modalHandler,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "text",
      name: "Keterangan",
      title: "Keterangan",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "numberFormatSatu",
      name: "Nominal",
      title: "Nominal",
      handler: modalHandlerNominal,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
  ];

  const Kirim = () => {
    let newValues = values;
    try {
      newValues["Nominal"] = newValues["Nominal"].toString();
      newValues["Tanggal"] = newValues["Tanggal"].toISOString();
    } catch (err) {}
    newValues["Type"] = "NonPO";
    newValues["Data"] = detail;

    // Tambahkan field File jika ada
    if (values.File && values.File.trim() !== "") {
      newValues["File"] = values.File;
    }

    if (params.transid) {
      newValues["Status"] = "1";
      mutationUpdate.mutate(newValues);
    } else {
      mutationAdd.mutate(newValues);
    }
  };

  const Approve = () => {
    let newValues = { ...values };

    // Pastikan BagianID string kosong jika null
    if (!newValues.BagianID) {
      newValues.BagianID = "";
    }

    try {
      if (newValues.Nominal) {
        newValues.Nominal = newValues.Nominal.toString();
      }
      if (newValues.Tanggal instanceof Date) {
        newValues.Tanggal = newValues.Tanggal.toISOString();
      }
    } catch (err) {
      console.error(err);
    }

    newValues["Type"] = "NonPO";
    newValues["Data"] = detail;

    // Kirim file yang sudah ada (jika ada)
    if (values.File && values.File.trim() !== "") {
      newValues["File"] = values.File;
    }

    mutationApproval.mutate(newValues);
  };

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col mt-5 p-6">
                <div className="flex w-full justify-end flex-col sm:flex-row ">
                  <button
                    onClick={() => navigate(-1)}
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    <BiArrowBack className="text-xl text-gray-800 pr-2" />
                    Kembali
                  </button>
                  {!params.approval ? (
                    <button
                      onClick={() => Kirim()}
                      className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                    >
                      {mutationAdd.isLoading ? (
                        <>
                          <svg
                            aria-hidden="true"
                            role="status"
                            className="inline mr-3 w-4 h-4 text-white animate-spin"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="#E5E7EB"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="currentColor"
                            />
                          </svg>
                          Loading
                        </>
                      ) : (
                        "Simpan"
                      )}
                    </button>
                  ) : (
                    <button
                      onClick={() => Approve()}
                      className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                    >
                      {mutationApproval.isLoading ? (
                        <>
                          <svg
                            aria-hidden="true"
                            role="status"
                            className="inline mr-3 w-4 h-4 text-white animate-spin"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="#E5E7EB"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="currentColor"
                            />
                          </svg>
                          Loading
                        </>
                      ) : (
                        "Kirim"
                      )}
                    </button>
                  )}
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"BisnisUnit"}
                    value={values}
                    name={"BisnisUnitID"}
                    title={"Bisnis Unit"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"text"}
                    value={values}
                    name={"JenisTransaksi"}
                    title={"Jenis Transaksi"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"text"}
                    value={values}
                    name={"DariKepada"}
                    title={"Dibayar kepada"}
                    onChange={changeHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                {values.BagianID !== "" && (
                  <div className="w-1/3">
                    <HrdInputGenerator
                      type={"Bagianv3"}
                      value={values}
                      name={"BagianID"}
                      title={"Bagian"}
                      onChange={customHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={true}
                      errors={errors}
                      disabled={true}
                    />
                  </div>
                )}
                {/* Jenis Pembayaran & Detail Pembayaran = sisi kas/bank (FAP).
                    Ditampilkan HANYA bila sudah terisi — permohonan non-FAP dibuat
                    tanpa keduanya, jadi tak perlu muncul kosong (konsisten dgn pola
                    Bagian/NoCek di form ini). */}
                {values.JenisCashJournal && values.JenisCashJournal !== "" && (
                  <div className="w-1/3">
                    <HrdInputGenerator
                      type={"text"}
                      value={values}
                      name={"JenisCashJournal"}
                      title={"Jenis Pembayaran"}
                      onChange={customHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={true}
                      errors={errors}
                      disabled={true}
                    />
                  </div>
                )}
                {values.DetailCashJournal && values.DetailCashJournal !== "" && (
                  <div className="w-1/3">
                    <HrdInputGenerator
                      type={"DetailPembayaran"}
                      value={values}
                      name={"DetailCashJournal"}
                      title={"Detail Pembayaran"}
                      onChange={customHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={true}
                      errors={errors}
                      disabled={true}
                    />
                  </div>
                )}
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"dateLock"}
                    value={values}
                    name={"Tanggal"}
                    title={"Tanggal"}
                    onChange={changeHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>

                {/* Tanggal Keperluan (read-only) — bila ada. */}
                {values.TanggalKeperluan && values.TanggalKeperluan !== "" && (
                  <div className="w-1/3 px-3 mb-6">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Tanggal Keperluan
                    </label>
                    <input
                      type="date"
                      value={values.TanggalKeperluan}
                      readOnly
                      disabled
                      className="appearance-none block w-full bg-gray-100 text-gray-700 border border-gray-300 rounded py-3 px-4 leading-tight cursor-not-allowed"
                    />
                  </div>
                )}

                {values.NoCek && (
                  <div className="w-1/2">
                    <HrdInputGenerator
                      type={"text"}
                      value={values}
                      name={"NoCek"}
                      title={"No Cek atau bilyed giro"}
                      onChange={changeHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={true}
                      errors={errors}
                      disabled={false}
                    />
                  </div>
                )}

                {/* SECTION ATTACHMENT (VIEW ONLY) - DITAMBAHKAN DISINI */}
                {values.File && values.File.trim() !== "" && (
                  <div className="w-full px-3 mb-4">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Attachment
                      <span className="text-blue-600 text-xs ml-2">
                        ✓ File tersedia
                      </span>
                    </label>

                    <div className="flex items-center space-x-2">
                      {/* Tombol Lihat File */}
                      <button
                        type="button"
                        onClick={() => getDataFromURL(values.File)}
                        className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 border border-blue-600 rounded shadow-sm"
                      >
                        Lihat File
                      </button>
                    </div>

                    {/* Info File - Ekstrak nama file dari field File */}
                    <div className="mt-2 p-2 bg-gray-50 rounded border">
                      <div className="flex items-center">
                        <span className="text-lg mr-2">
                          {getFileIcon(extractFileName(values.File))}
                        </span>
                        <span className="text-sm text-gray-700 truncate">
                          {extractFileName(values.File)}
                        </span>
                      </div>

                      {/* Info UUID */}
                      {values.File && values.File.includes("-") && (
                        <p className="text-xs text-gray-500 mt-1">
                          UUID: {values.File.split("-")[0]}
                        </p>
                      )}
                    </div>
                  </div>
                )}

                <div className="w-1/2">
                  <HrdInputGenerator
                    type={"text"}
                    value={values}
                    name={"Keterangan"}
                    title={"Keterangan"}
                    onChange={changeHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"numberView"}
                    value={values}
                    name={"Nominal"}
                    title={"Nominal"}
                    onChange={changeHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <hr />
                <DynamicTableSimple
                  data={detail}
                  header={header}
                  OnClick={ModalOpener}
                  name={"Purchase Requisition"}
                  barang={barang.data}
                  edit={ModalEdit}
                  delete={ModalDelete}
                  account={detailAccount.data}
                />
              </div>
            </Card>
            <Modal
              size="lg"
              active={showModal}
              toggler={() => {
                setShowModal(true);
              }}
            >
              <ModalHeader
                className="mt-20"
                toggler={() => {
                  setShowModal(false);
                  setShowModalEdit(false);
                }}
              >
                {showModalEdit ? "Edit Data" : "Tambah Data"}
              </ModalHeader>
              <ModalBody>
                <form className="w-full " onSubmit={submitHandler}>
                  {inputBuilder.map(
                    (
                      {
                        type,
                        name,
                        title,
                        handler,
                        modifiers,
                        size,
                        required,
                        disabled,
                        edit,
                      },
                      id
                    ) => {
                      if (!edit || showModalEdit) {
                        return (
                          <HrdInputGenerator
                            type={type}
                            value={modalDetail}
                            name={name}
                            title={title}
                            onChange={handler}
                            touched={touched}
                            buttonTouched={buttonTouched}
                            modifiers={modifiers}
                            size={size}
                            required={required}
                            errors={errors}
                            disabled={disabled}
                          />
                        );
                      }
                    }
                  )}
                </form>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="red"
                  buttonType="link"
                  onClick={() => {
                    setShowModal(false);
                    setShowModalEdit(false);
                  }}
                  ripple="dark"
                >
                  Cancel
                </Button>

                <Button
                  color={isValid || !isValid ? "green" : "blueGray"}
                  disabled={mutation.isLoading}
                  onClick={() => {
                    if (!isValid && changed) {
                      setButtonTouched(true);
                    }
                    let tempIsValid = isValid;
                    if (!isValid) {
                    }
                    if (showModalEdit) {
                      let newValues = [...detail];
                      newValues[modalID] = modalDetail;
                      let totals = 0;
                      newValues.map(({ Nominal }, id) => {
                        totals += parseFloat(Nominal);
                      });
                      customHandler(totals, "Nominal");
                      setDetail(newValues);
                      setModalDetail(initialStateModal);
                      setShowModal(false);
                      setShowModalEdit(false);
                    } else {
                      const newValues = [...detail, modalDetail];
                      let totals = 0;
                      newValues.map(({ Nominal }, id) => {
                        totals += parseFloat(Nominal);
                      });
                      customHandler(totals, "Nominal");

                      setDetail(newValues);
                      setModalDetail(initialStateModal);
                      setShowModal(false);
                    }
                  }}
                  ripple={isValid ? "light" : ""}
                >
                  {showModalEdit ? "Ubah" : "Tambah"}
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApprovalCashBank;
